import { useCallback, useEffect, useRef, useState } from "react";
import { Calculate, Events, Logout, Membership, Wallet } from "../../../icons";
import { useNavigate } from "react-router-dom";
import {
  getCookies,
  getLocalStorage,
  removeAllCookies,
} from "../../../helpers/storage";
import { ROUTES } from "../../../constants/routes";
import { useLogoutMutation } from "../../../store/api/authApi";
import ProfileImageComp from "../profile";
import { clearAllState } from "../../../helpers/storage";
import { Link } from "react-router-dom";
import { toastError } from "../../toast";
import ProfileBadgeAvatar from "../../user/user-profile/profile-avatar";
import Button from "../button";
import Modal from "../modals";
const PopoverProfile = () => {
  const [showPopover, setShowPopover] = useState(false);
  const [isAllowHideOnBackClick, setIsAllowHideOnBackClick] = useState(true);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const logoutRef = useRef(null);
  const logoutModalRef = useRef(null);

  const navigate = useNavigate();

  const [logout, { isLoading }] = useLogoutMutation();

  const user = JSON.parse(getLocalStorage("userData") || "{}");

  const accessToken = getCookies("accessToken");

  const handleGoalVestorClick = useCallback(() => {
    if (user?._id && accessToken) {
      const targetWindow = window.open(
        `https://calculators.onepercentclub.io/fd-calculator/?userId=${user?._id}`,
        "_blank",
      );
      if (targetWindow) {
        setTimeout(() => {
          targetWindow.postMessage(
            { userId: user?._id, accessToken },
            "https://calculators.onepercentclub.io/fd-calculator",
          );
        }, 1000);
      }
    }
  }, [user?._id, accessToken]);
  useEffect(() => {
    document.addEventListener("mousedown", handleHidewhenClickedOutside);
    return () => {
      document.removeEventListener("mousedown", handleHidewhenClickedOutside);
    };
  }, [isAllowHideOnBackClick]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        showLogoutModal &&
        logoutModalRef.current &&
        !(logoutModalRef.current as any).contains(event.target)
      ) {
        setShowLogoutModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showLogoutModal]);

  const handleHidewhenClickedOutside = (e: any) => {
    const popOverElement = ["profile-pic", "profile-pic-img"];

    if (!isAllowHideOnBackClick) {
      return;
    }
    if (!popOverElement.includes(e.target.id)) setShowPopover(false);
  };

  const handleLogout = async () => {
    if (!showLogoutModal) {
      setShowLogoutModal(true);
      return;
    }
    try {
      await logout();
      if (typeof window !== "undefined" && window.webengage) {
        window.webengage.user.logout();
      }
      clearAllState();
      navigate(ROUTES.AUTH_PHONE_NUMBER);
      removeAllCookies();
    } catch (error) {
      toastError({ message: error });
    }
  };

  const showPopoverHandler = () => {
    setShowPopover(!showPopover);
  };

  return (
    <div>
      {showLogoutModal && (
        <Modal size="small" isOpen={true} customClass="my-[15%]">
          <div className="bg-white rounded-xl mx-3" ref={logoutModalRef}>
            <div className=" w-full flex flex-col items-center gap-4 border-b  p-4 pt-10">
              <div className="text-primary-900 text-[28px] font-bold leading-8 tracking-tight">
                Log Out
              </div>
              <div className="text-center text-primary-900 text-base font-normal leading-5">
                Are you sure you want to log out?
              </div>
              <img
                src="/assets/logout/logout.png"
                className="w-44 h-44"
                alt=""
              ></img>
            </div>
            <div className="w-full flex gap-2 justify-end py-4">
              <Button
                variant="secondary"
                onClick={() => {
                  setShowLogoutModal(false);
                }}
              >
                Cancel
              </Button>
              <Button
                isSubmitting={isLoading}
                variant="danger"
                onClick={() => {
                  handleLogout();
                }}
              >
                Log Out
              </Button>
            </div>
          </div>
        </Modal>
      )}
      <div
        className=" relative cursor-pointer"
        id="profile-pic"
        onClick={showPopoverHandler}
      >
        {user?.badge ? (
          <div className={`relative w-10 h-[40px] `}>
            <ProfileBadgeAvatar
              profileImage={user?.profile_picture}
              customDivClassName="absolute h-10 w-10 border-4 z-1"
              customImgClassName="h-[40px] w-[40px] absolute rounded-full p-[3px]"
              customIconDivClassName="absolute z-[120] -bottom-[5px] left-[15px]"
              customStyle1="w-[50px] h-[14px]  absolute -bottom-2 z-[100] overflow-hidden"
              customStyle2="w-[200px] h-4  absolute top-3 z-10 -left-10 overflow-hidden"
              customStarWidth={10}
              customStarHeight={10}
              customStyle3="w-[34px] h-[34px]"
              badge={user?.badge}
            />
          </div>
        ) : (
          <ProfileImageComp
            imageUrl={user?.profile_picture}
            customClass="h-9 w-9"
            is_opc={user?.memberships?.is_opc}
          />
        )}
        {showPopover ? (
          <div
            id="popover-container"
            className="bg-white z-100 shadow-dark-card absolute top-12 right-0 p-4 rounded-xl-10 w-[258px]"
            onMouseEnter={() => setIsAllowHideOnBackClick(false)}
            onMouseLeave={() => setIsAllowHideOnBackClick(true)}
          >
            <Link to={ROUTES.USER_PROFILE.replace(":user_id", user?._id)}>
              <div className="flex items-center space-x-2">
                {user?.badge ? (
                  <div className={`relative w-12 h-[48px] `}>
                    <ProfileBadgeAvatar
                      profileImage={user?.profile_picture}
                      customDivClassName="absolute h-12 w-12 border-4 z-1"
                      customImgClassName="h-[48px] w-[48px] absolute rounded-full p-1"
                      customIconDivClassName="absolute z-[120] -bottom-[5px] left-[18px]"
                      customStyle1="w-[50px] h-4  absolute -bottom-2 z-[100] overflow-hidden"
                      customStyle2="w-[200px] h-5 absolute top-3 z-10 -left-10 overflow-hidden"
                      customStarWidth={12}
                      customStarHeight={12}
                      customStyle3="w-[40px] h-[40px]"
                      badge={user?.badge}
                    />
                  </div>
                ) : (
                  <ProfileImageComp
                    imageUrl={user?.profile_picture}
                    customClass="h-12 w-12"
                    is_opc={user?.memberships?.is_opc}
                  />
                )}
                <div>
                  <div className="text-lg font-semibold text-gray-900">
                    {user?.first_name} {user?.last_name}
                  </div>
                  <p className="text-sm text-gray-500">{user?.designation}</p>
                </div>
              </div>
            </Link>
            <Link to={ROUTES.MEMBERSHIP}>
              <div className="flex mt-[8px] pt-[16px] pb-[16px] border-b-[1px] border-[#EBEBEB]">
                <div className="flex items-center justify-center">
                  <Membership />
                </div>
                <div className="text-[17px] font-[590] text-gray-900 ml-2">
                  Membership
                </div>
              </div>
            </Link>
            <div
              className="flex pt-[16px] pb-[16px] border-b-[1px] border-[#EBEBEB]"
              onClick={() => navigate(ROUTES.EVENTS)}
            >
              <div className="flex items-center justify-center">
                <Events />
              </div>
              <div className="text-[17px] font-[590] text-[#090909] ml-2">
                My Events
              </div>
            </div>
            <Link to={ROUTES.WALLET}>
              <div className="flex pt-[16px] pb-[16px] border-b-[1px] border-[#EBEBEB]">
                <div className="flex items-center justify-center">
                  <Wallet />
                </div>
                <div className="text-[17px] font-[590] text-[#090909] ml-2">
                  Wallet
                </div>
              </div>
            </Link>
            <div
              className="flex pt-[16px] pb-[16px] border-b-[1px] border-[#EBEBEB]"
              onClick={() => handleGoalVestorClick()}
            >
              <div className="flex items-center justify-center">
                <Calculate width={24} height={20} />
              </div>
              <div className="text-[17px] font-[590] text-[#090909] ml-2">
                Calculate
              </div>
            </div>
            <div className="flex pt-[12px] pb-[12px] border-b-[1px] border-[#EBEBEB]">
              <div className="text-[15px] font-[400] text-[#090909]">
                <a href="mailto:support@onepercentclub.io">Help & Support</a>
              </div>
            </div>
            <div className="flex pt-[12px] pb-[12px] border-b-[1px] border-[#EBEBEB]">
              <div className="text-[15px] font-[400] text-[#090909]">
                <a href="https://www.onepercentclub.io/privacy-policy">
                  View Policies
                </a>
              </div>
            </div>
            <div ref={logoutRef} onClick={handleLogout}>
              <div className="flex mt-[12px] items-center justify-between">
                <span className="text-[15px] font-[510] text-[#090909]">
                  Logout
                </span>
                <Logout />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PopoverProfile;
